export default from './comment-form-image';



// WEBPACK FOOTER //
// ./app/components/comment-form-image/index.js